import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import { FormGroup, Grid, Switch, Tooltip, Typography,Button,styled ,Select,MenuItem,InputLabel,FormControl} from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList';

import { pageStore } from '../../../common';

const { usePageStore } = pageStore('contracts-landing');

function ContractsTopFilter({ intl, pending, customFilter, handleRefresh,contractState="finalized",archivedState, actions: { setMulti,setOpenAdvanceFiltersDialog,setContractState } }) {
    const filter = usePageStore( s => s?.filter || []);
    // useEffect(() => {
    //     setTimeout(() => {
    //         if (isFinalized) {
    //             setMulti({
    //                 list: [],
    //                 customFilter: [{
    //                     field: 'isPayer',
    //                     equator: 'equals',
    //                     value: true,
    //                 },
    //                 {
    //                     field: "contractState.name",
    //                     equator: "equals",
    //                     value: "Finalized",
    //                 }]
    //             });
    //         } else {
    //             setMulti({
    //                 list: [],
    //                 customFilter: [{
    //                     field: 'isPayer',
    //                     equator: 'equals',
    //                     value: true,
    //                 }]
    //             });
    //         }
    //         handleRefresh();
    //     }, 200);

    // }, [isFinalized, setMulti])

    const handleStateChange = (event) => {
        const value = event.target.value
        setContractState(value);
        handleRefresh(value);
    };

    // const openAdvancedFiltersPanel = () => {
    //     setOpenAdvanceFiltersDialog(true)
    // }

    return (
        <Grid container spacing={7}>
            {/* <Grid item>
                <FormGroup>
                    <Tooltip title='Toggle to view Archived Contracts'>
                        <Typography component="div">
                            <Grid component="label" container alignItems="center" spacing={0} className='mb-0'>
                                <Grid item>
                                    <Switch
                                        disabled={pending}
                                        checked={archivedState}
                                        onChange={handleArchivedStateChange}
                                        name="userActive" />
                                </Grid>
                                <Grid item>Archived</Grid>
                            </Grid>
                        </Typography>
                    </Tooltip>

                </FormGroup>
            </Grid> */}
            {/* <Grid item>
                <FormGroup>
                    <Tooltip title='Toggle to view finalized contracts or all contracts'>
                        <Typography component="div">
                            <Grid component="label" container alignItems="center" spacing={0} className='mb-0'>
                                <Grid item>All</Grid>
                                <Grid item>
                                    <Switch
                                        disabled={pending}
                                        checked={finalizedState}
                                        onChange={handleStateChange}
                                        name="userActive" />
                                </Grid>
                                <Grid item>Finalized</Grid>
                            </Grid>
                        </Typography>
                    </Tooltip>

                </FormGroup>
            </Grid> */}
            <Grid item>
            <FormControl sx={{width:"170px"}}>
                        <InputLabel id="ContractState">Contract State</InputLabel>
                        <Select
                            // disabled={pending || ignoreDueToQuickSearch}
                            labelId="ContractState"
                            id="ContractState"
                            label="Contract State"
                            // defaultValue=""
                            value={contractState || "all"}
                            onChange={handleStateChange}
                        >
                            <MenuItem value="all">All</MenuItem>
                            <MenuItem value='draft'>Draft</MenuItem>
                            <MenuItem value='finalized'>Finalized</MenuItem>
                            <MenuItem value='archived'>Archived</MenuItem>
                            <MenuItem value='model'>Model</MenuItem>
                        </Select>
                    </FormControl>


            </Grid>
{/* 
            <Grid item>
            <Button
          onClick={() =>setOpenAdvanceFiltersDialog(true)}

          variant="contained" color='primary'
          startIcon={

            !filter.length ? <FilterListIcon /> : <></>
          }
          endIcon={
            filter.length ? <> ({<NumberChip>{filter.length}</NumberChip>})</> : <></>

          }
        >Advanced Filters</Button>                </Grid> */}
        </Grid>
    )
}
const NumberChip = styled('div')({
    fontSize: '12px !important',
    color: 'white',
    padding: '0 2.5px 0 2.5px',
    position:'relative',
    bottom:"1px"
  })
  

export default ContractsTopFilter


